// Orders (and the balance they affect) ARE cross-cutting — the
// TopBar, the Orders page, and the Market purchase flow all need
// to agree on them — so this hook reads/writes the global store
// rather than keeping its own local copy.

import { useCallback } from 'react';
import { useAppStore } from '@/store/AppStore';
import { api } from '@/services/api';
import type { Product } from '@/types/product';
import type { RecipientInfo } from '@/types/order';

export function useOrders() {
  const { state, dispatch } = useAppStore();

  const placeOrder = useCallback(
    async (product: Product, recipient: RecipientInfo) => {
      const order = await api.createOrder({ product, recipient });
      dispatch({ type: 'ADD_ORDER', payload: order });
      if (product.category === 'stars' && recipient.type === 'self') {
        dispatch({ type: 'INCREMENT_BALANCE', payload: product.amount });
      }
      return order;
    },
    [dispatch],
  );

  return { orders: state.orders, loading: state.ordersLoading, placeOrder };
}
